import {ContextAware} from "@/app/contexts/detail.context";
import {getObjectContentsFromPath} from "@/app/helpers/stringpath.helper";
import Vue from "vue";
import axios, {AxiosResponse} from "axios";
import store from "@/store";
import {DynamicForm} from "@/app/dynamic-components/forms/dynamic-form.model";
import {ruleEngine} from "@/app/services/rule.engine";

class ResolveEngine {
    //dynamocfprùs

    public resolvePlaceholders(data: any, context: ContextAware): any {
        if(!data) return data;
        if (typeof data === "string") {
            return this.resolvePlaceholdersString(data,context);
        }
        return JSON.parse(this.resolvePlaceholdersString(JSON.stringify(data),context));
    }

    private resolvePlaceholdersString(str: any, context: ContextAware): any {
        const calculatedReplaceRegex = /\${([^$}]*)}/;

        let replaceRegex;
        let c = 0;
        while ((replaceRegex = calculatedReplaceRegex.exec(str)) && c < 1000) {
            const fallbackorder = replaceRegex[1].split(';');
            //console.log("resolvePlaceholdersString", str, replaceRegex);
            let replaced = false;
            for (let i = 0; i < fallbackorder.length && !replaced; i++) {
                const placeholder = fallbackorder[i];
                let value = this.resolveFieldValue(placeholder, context);
                // console.log("resolveDataPath", str, value);
                if (Array.isArray(value)) {
                    value = Array.from(value).length <= 0 ? null : value[0];
                }
                if(value){
                    str = str.replaceAll(replaceRegex[0], value ? value : "$nan");
                    // console.log("found regex", JSON.stringify(replaceRegex), value, str);
                    replaced = true;
                }
            }
            if(!replaced){
                str = str.replaceAll(replaceRegex[0], "$nan");
                // console.log("found regex", JSON.stringify(replaceRegex), "$nan", str);
            }
            c++;
        }
        return str;
    }

    private resolveDataPath(dataPath: string, context: ContextAware): any {
        if (!dataPath) return null;
        if (dataPath.startsWith("data.")) dataPath = dataPath.replace("data.", "");
        return getObjectContentsFromPath(dataPath, context.getData());
    }

    private async resolveDataPathAsync(dataPath: string, context: ContextAware, vue: Vue): Promise<any> {
        if (!dataPath) return null;
        if (dataPath.startsWith("data.")) dataPath = dataPath.replace("data.", "");
        return getObjectContentsFromPath(dataPath, context.getData());
    }

    public resolveFieldValue(field: string, context: ContextAware) : any {
        if(field === undefined || field === null) return null;
        const segements = field.split('|'); // the | is a pipe to next function
        let value;
        for (const segement of segements) {
            const segementParts = segement.split('[');
            if(segementParts.length === 1){
                //has no pipe operator
                if(segement.startsWith("data.")){
                    value = this.resolveDataPath(segement, context);
                }else{
                    value = segement
                }
            }else{
                //has pipe operator
                const func = segementParts[0];
                const argsString = segementParts[1].substring(0,segementParts[1].length-1);
                const args = argsString.split(';');
                let ruleResult = false;
                let argIndex = 0;

                switch (func) {
                    case "switch":
                        // switch matches the first result that resolves as a true rule. Format is always result, rule combo.
                        // so switch[data.bla;data.blaif:{eq:true;data.bla2};data.blaif2:{eq:true}]
                        while (!ruleResult) {
                            if((argIndex + 1) >= args.length ){
                                value = null;
                                break;
                            }

                            let result = args[argIndex];
                            if(result.startsWith("data.")){
                                result = this.resolveDataPath(result, context);
                            }

                            const rule = args[argIndex+1];
                            ruleResult = ruleEngine.resolveRule(context, rule);
                            if(ruleResult){
                                value = result;
                                ruleResult = true;
                            }
                            argIndex += 2;
                            console.warn("run", result,rule,ruleResult, args.length, args.length)
                        }
                        break;
                    case "lookup":
                        value = this.resolveDataPath(args[0], context);
                        break;
                    case "select":
                        value = getObjectContentsFromPath(args[0], value);
                        break;
                    case "length":
                        if(Array.isArray(value))
                            value = ''+value.length;
                        else if(!value){
                            value = 0;
                        }else{
                            value = 1;
                        }
                        break;
                    case "date":
                        if(value === 'now'){
                            value = new Date().getTime()
                        }else{
                            value = new Date(value).getTime();
                        }
                        break;
                    case "addSeconds":
                        if(!Number.isNaN(argsString)){
                            const newDate =  new Date(value);
                            newDate.setSeconds(newDate.getSeconds() + Number.parseInt(argsString, 10));
                            value = newDate.getTime();
                        }
                        break;
                    case "addMinutes":
                        if(!Number.isNaN(argsString)){
                            const newDate =  new Date(value);
                            newDate.setMinutes(newDate.getMinutes() + Number.parseInt(argsString, 10));
                            value = newDate.getTime();
                        }
                        break;
                    case "addHours":
                        if(!Number.isNaN(argsString)){
                            const newDate =  new Date(value);
                            newDate.setHours(newDate.getHours() + Number.parseInt(argsString, 10));
                            value = newDate.getTime();
                        }
                        break;
                    case "addDays":
                        if(!Number.isNaN(argsString)){
                            const newDate =  new Date(value);
                            newDate.setDate(newDate.getDate() + Number.parseInt(argsString, 10));
                            value = newDate.getTime();
                        }
                        break;
                    case "addWeeks":
                        if(!Number.isNaN(argsString)){
                            const newDate =  new Date(value);
                            newDate.setDate(newDate.getDate() + Number.parseInt(argsString, 10) * 7);
                            value = newDate.getTime();
                        }
                        break;
                    case "addMonths":
                        if(!Number.isNaN(argsString)){
                            const newDate =  new Date(value);
                            newDate.setMonth(newDate.getMonth() + Number.parseInt(argsString, 10));
                            value = newDate.getTime();
                        }
                        break;
                    case "addYears":
                        if(!Number.isNaN(argsString)){
                            const newDate =  new Date(value);
                            newDate.setFullYear(newDate.getFullYear() + Number.parseInt(argsString, 10));
                            value = newDate.getTime();
                        }
                        break;
                    case "startOfDay":
                        if(!Number.isNaN(argsString)){
                            const newDate =  new Date(value);
                            newDate.setHours(0);
                            newDate.setMinutes(0)
                            value = newDate.getTime();
                        }
                        break;
                    default:
                        break;
                }
            }
        }
        return value;
    }

    public async resolveFieldValueAsync(field: string, context: ContextAware, vue: Vue) : Promise<any> {
        const segements = field.split('|'); // the | is a pipe to next function
        let value;
        for (const segement of segements) {
            const segementParts = segement.split('[');
            if(segementParts.length === 1){
                //has no pipe operator
                if(segement.startsWith("data.")){
                    value = this.resolveDataPathAsync(segement, context, vue);
                }else{
                    value = segement
                }
            }else {
                const func = segementParts[0];
                const argsString = segementParts[1].substring(0,segementParts[1].length-1);
                const args = argsString.split(';');

                switch (func) {
                    case "lookup":
                        value = this.resolveDataPathAsync(args[0], context, vue);
                        break;
                    case "url":
                        if(args[0].startsWith('api/')) args[0] = vue.$store.state.appConfig.apiBaseUrl + args[0];
                        if(args[0].includes('?')){
                            const pathParts = args[0].split('?');
                            const params = {};
                            pathParts[1].split('&').forEach(value1 => {
                                const sp = value1.split('=');
                                params[sp[0]] = sp[1].replaceAll('"',"'");
                            })
                            console.warn("url", pathParts[0], params);
                            value = await axios.get<any>(pathParts[0], {params: params});
                        }else{
                            console.warn("url", args[0]);
                            value = await axios.get<any>(args[0]);
                        }

                        break;
                    case "select":
                        value = getObjectContentsFromPath(args[0], value);
                        break;
                    case "length":
                        if(Array.isArray(value))
                            value = ''+value.length;
                        else if(!value){
                            value = 0;
                        }else{
                            value = 1;
                        }
                        break;
                    case "date":
                        if(value === 'now'){
                            value = new Date().getTime()
                        }else{
                            value = new Date(value).getTime();
                        }
                        break;
                    case "addSeconds":
                        if(!Number.isNaN(argsString)){
                            const newDate =  new Date(value);
                            newDate.setSeconds(newDate.getSeconds() + Number.parseInt(argsString, 10));
                            value = newDate.getTime();
                        }
                        break;
                    case "addMinutes":
                        if(!Number.isNaN(argsString)){
                            const newDate =  new Date(value);
                            newDate.setMinutes(newDate.getMinutes() + Number.parseInt(argsString, 10));
                            value = newDate.getTime();
                        }
                        break;
                    case "addHours":
                        if(!Number.isNaN(argsString)){
                            const newDate =  new Date(value);
                            newDate.setHours(newDate.getHours() + Number.parseInt(argsString, 10));
                            value = newDate.getTime();
                        }
                        break;
                    case "addDays":
                        if(!Number.isNaN(argsString)){
                            const newDate =  new Date(value);
                            newDate.setDate(newDate.getDate() + Number.parseInt(argsString, 10));
                            value = newDate.getTime();
                        }
                        break;
                    case "addWeeks":
                        if(!Number.isNaN(argsString)){
                            const newDate =  new Date(value);
                            newDate.setDate(newDate.getDate() + Number.parseInt(argsString, 10) * 7);
                            value = newDate.getTime();
                        }
                        break;
                    case "addMonths":
                        if(!Number.isNaN(argsString)){
                            const newDate =  new Date(value);
                            newDate.setMonth(newDate.getMonth() + Number.parseInt(argsString, 10));
                            value = newDate.getTime();
                        }
                        break;
                    case "addYears":
                        if(!Number.isNaN(argsString)){
                            const newDate =  new Date(value);
                            newDate.setFullYear(newDate.getFullYear() + Number.parseInt(argsString, 10));
                            value = newDate.getTime();
                        }
                        break;
                    case "startOfDay":
                        if(!Number.isNaN(argsString)){
                            const newDate =  new Date(value);
                            newDate.setHours(0);
                            newDate.setMinutes(0)
                            value = newDate.getTime();
                        }
                        break;
                    default:
                        break;
                }
            }
        }
        return value;
    }

    private async resolveHttpCall(data: string) {
        const entry = data.substring(4, data.length -1).split(',');
        const method = entry[0].toLowerCase();
        let url = entry[1];
        if(!url.startsWith("http")){
            url = store.state.appConfig.apiBaseUrl + entry[1];
        }
        let request: Promise<AxiosResponse<any>> | null = null;

        if(method === 'get'){
            request = axios.get(url);
        } else if(method === 'post'){
            request = axios.post(url);
        } else if(method === 'put'){
            request = axios.put(url);
        } else if(method === 'delete'){
            request = axios.delete(url);
        } else if(method === 'patch'){
            request = axios.patch(url);
        } else if(method === 'options'){
            request = axios.options(url);
        } else if(method === 'head'){
            request = axios.head(url);
        }
        const result = await request;
        return result?.data;
    }
}

export const resolveEngine = new ResolveEngine();

